import Axios, { AxiosResponse } from 'axios';
import { config } from '../../../config';
import { RidersApiParams } from '../../../typings/api';

export const getCompetitionRiders = async ({
  id,
  page,
  countryCode,
  search,
}: RidersApiParams) => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/competition-hub/riders/${id}`, {
    params: {
      page,
      countryCode,
      search,
    },
  });

  return data;
};

export const getRiders = async ({
  page,
  countryCode,
  discipline,
  category,
  year,
  search,
}: RidersApiParams) => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/riders/${discipline}/${year}`, {
    params: {
      page,
      country: countryCode,
      category,
      search,
    },
  });

  return data;
};

export const getTeams = async ({
  page,
  countryCode,
  discipline,
  category,
  year,
  search,
}: RidersApiParams) => {
  const { data }: AxiosResponse = await Axios.get(`${config.apiUrl}/teams/${discipline}/${year}`, {
    params: {
      page,
      country: countryCode,
      category,
      search,
    },
  });

  return data;
};
